// AUTO-GENERATED - DO NOT EDIT
// Generated by scripts/generateComponentRegistry.mjs
// Run: node scripts/generateComponentRegistry.mjs

export interface ComponentInfo {
    name: string;
    fileName: string;
    folder: string;
    path: string;
    importPath: string;
}

export const componentRegistry: ComponentInfo[] = [
    {
        "name": "AdminAnalytics",
        "fileName": "AdminAnalytics",
        "folder": "admin",
        "path": "src/components/admin/AdminAnalytics.tsx",
        "importPath": "@/components/admin/AdminAnalytics"
    },
    {
        "name": "AdminReportModal",
        "fileName": "AdminReportModal",
        "folder": "admin",
        "path": "src/components/admin/AdminReportModal.tsx",
        "importPath": "@/components/admin/AdminReportModal"
    },
    {
        "name": "Dashboard",
        "fileName": "ReportsDashboard",
        "folder": "admin",
        "path": "src/components/admin/ReportsDashboard.tsx",
        "importPath": "@/components/admin/ReportsDashboard"
    },
    {
        "name": "FeedbackDashboard",
        "fileName": "FeedbackDashboard",
        "folder": "admin",
        "path": "src/components/admin/FeedbackDashboard.tsx",
        "importPath": "@/components/admin/FeedbackDashboard"
    },
    {
        "name": "ReportCard",
        "fileName": "ReportCard",
        "folder": "admin",
        "path": "src/components/admin/ReportCard.tsx",
        "importPath": "@/components/admin/ReportCard"
    },
    {
        "name": "RewardKudosModal",
        "fileName": "RewardKudosModal",
        "folder": "admin",
        "path": "src/components/admin/RewardKudosModal.tsx",
        "importPath": "@/components/admin/RewardKudosModal"
    },
    {
        "name": "Alert",
        "fileName": "Alert",
        "folder": "common",
        "path": "src/components/common/Alert.tsx",
        "importPath": "@/components/common/Alert"
    },
    {
        "name": "AlertHost",
        "fileName": "AlertHost",
        "folder": "common",
        "path": "src/components/common/AlertHost.tsx",
        "importPath": "@/components/common/AlertHost"
    },
    {
        "name": "Button",
        "fileName": "Button",
        "folder": "common",
        "path": "src/components/common/Button.tsx",
        "importPath": "@/components/common/Button"
    },
    {
        "name": "ConnectingOverlay",
        "fileName": "ConnectingOverlay",
        "folder": "common",
        "path": "src/components/common/ConnectingOverlay.tsx",
        "importPath": "@/components/common/ConnectingOverlay"
    },
    {
        "name": "Drawer",
        "fileName": "Drawer",
        "folder": "common",
        "path": "src/components/common/Drawer.tsx",
        "importPath": "@/components/common/Drawer"
    },
    {
        "name": "Dropdown",
        "fileName": "Dropdown",
        "folder": "common",
        "path": "src/components/common/Dropdown.tsx",
        "importPath": "@/components/common/Dropdown"
    },
    {
        "name": "FeedbackModal",
        "fileName": "FeedbackModal",
        "folder": "common",
        "path": "src/components/common/FeedbackModal.tsx",
        "importPath": "@/components/common/FeedbackModal"
    },
    {
        "name": "Modal",
        "fileName": "Modal",
        "folder": "common",
        "path": "src/components/common/Modal.tsx",
        "importPath": "@/components/common/Modal"
    },
    {
        "name": "Pill",
        "fileName": "Pill",
        "folder": "common",
        "path": "src/components/common/Pill.tsx",
        "importPath": "@/components/common/Pill"
    },
    {
        "name": "SlideInOnScroll",
        "fileName": "SlideInOnScroll",
        "folder": "common",
        "path": "src/components/common/SlideInOnScroll.tsx",
        "importPath": "@/components/common/SlideInOnScroll"
    },
    {
        "name": "Spinner",
        "fileName": "Spinner",
        "folder": "common",
        "path": "src/components/common/Spinner.tsx",
        "importPath": "@/components/common/Spinner"
    },
    {
        "name": "TextWithLinks",
        "fileName": "TextWithLinks",
        "folder": "common",
        "path": "src/components/common/TextWithLinks.tsx",
        "importPath": "@/components/common/TextWithLinks"
    },
    {
        "name": "Communities",
        "fileName": "Communities",
        "folder": "communities",
        "path": "src/components/communities/Communities.tsx",
        "importPath": "@/components/communities/Communities"
    },
    {
        "name": "DevToolsPanel",
        "fileName": "DevToolsPanel",
        "folder": "dev",
        "path": "src/components/dev/DevToolsPanel.tsx",
        "importPath": "@/components/dev/DevToolsPanel"
    },
    {
        "name": "AddCommentsSection",
        "fileName": "AddCommentsSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/AddCommentsSection.tsx",
        "importPath": "@/components/dev/sections/AddCommentsSection"
    },
    {
        "name": "AddHandshakeSection",
        "fileName": "AddHandshakeSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/AddHandshakeSection.tsx",
        "importPath": "@/components/dev/sections/AddHandshakeSection"
    },
    {
        "name": "LogsFilterBar",
        "fileName": "LogsFilterBar",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/LogsFilterBar.tsx",
        "importPath": "@/components/dev/sections/LogsFilterBar"
    },
    {
        "name": "LogsSection",
        "fileName": "LogsSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/LogsSection.tsx",
        "importPath": "@/components/dev/sections/LogsSection"
    },
    {
        "name": "PostDebugSection",
        "fileName": "PostDebugSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/PostDebugSection.tsx",
        "importPath": "@/components/dev/sections/PostDebugSection"
    },
    {
        "name": "RecordingsSection",
        "fileName": "RecordingsSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/RecordingsSection.tsx",
        "importPath": "@/components/dev/sections/RecordingsSection"
    },
    {
        "name": "SearchDebugSection",
        "fileName": "SearchDebugSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/SearchDebugSection.tsx",
        "importPath": "@/components/dev/sections/SearchDebugSection"
    },
    {
        "name": "StateDebugSection",
        "fileName": "StateDebugSection",
        "folder": "dev/sections",
        "path": "src/components/dev/sections/StateDebugSection.tsx",
        "importPath": "@/components/dev/sections/StateDebugSection"
    },
    {
        "name": "CreateEvent",
        "fileName": "CreateEvent",
        "folder": "events",
        "path": "src/components/events/CreateEvent.tsx",
        "importPath": "@/components/events/CreateEvent"
    },
    {
        "name": "EventCard",
        "fileName": "EventCard",
        "folder": "events",
        "path": "src/components/events/EventCard.tsx",
        "importPath": "@/components/events/EventCard"
    },
    {
        "name": "EventDetails",
        "fileName": "EventDetails",
        "folder": "events",
        "path": "src/components/events/EventDetails.tsx",
        "importPath": "@/components/events/EventDetails"
    },
    {
        "name": "Events",
        "fileName": "EventsCalendar",
        "folder": "events",
        "path": "src/components/events/EventsCalendar.tsx",
        "importPath": "@/components/events/EventsCalendar"
    },
    {
        "name": "EventsCarousel",
        "fileName": "EventsCarousel",
        "folder": "events",
        "path": "src/components/events/EventsCarousel.tsx",
        "importPath": "@/components/events/EventsCarousel"
    },
    {
        "name": "GanttEventsCalendar",
        "fileName": "GanttEventsCalendar",
        "folder": "events",
        "path": "src/components/events/GanttEventsCalendar.tsx",
        "importPath": "@/components/events/GanttEventsCalendar"
    },
    {
        "name": "MobileEventListView",
        "fileName": "MobileEventListView",
        "folder": "events",
        "path": "src/components/events/MobileEventListView.tsx",
        "importPath": "@/components/events/MobileEventListView"
    },
    {
        "name": "DropdownPicker",
        "fileName": "DropdownPicker",
        "folder": "forms",
        "path": "src/components/forms/DropdownPicker.tsx",
        "importPath": "@/components/forms/DropdownPicker"
    },
    {
        "name": "FilePicker",
        "fileName": "FilePicker",
        "folder": "forms",
        "path": "src/components/forms/FilePicker.tsx",
        "importPath": "@/components/forms/FilePicker"
    },
    {
        "name": "Form",
        "fileName": "Form",
        "folder": "forms",
        "path": "src/components/forms/Form.tsx",
        "importPath": "@/components/forms/Form"
    },
    {
        "name": "FormField",
        "fileName": "FormField",
        "folder": "forms",
        "path": "src/components/forms/FormField.tsx",
        "importPath": "@/components/forms/FormField"
    },
    {
        "name": "ImagePicker",
        "fileName": "ImagePicker",
        "folder": "forms",
        "path": "src/components/forms/ImagePicker.tsx",
        "importPath": "@/components/forms/ImagePicker"
    },
    {
        "name": "Input",
        "fileName": "Input",
        "folder": "forms",
        "path": "src/components/forms/Input.tsx",
        "importPath": "@/components/forms/Input"
    },
    {
        "name": "HandshakeCard",
        "fileName": "HandshakeCard",
        "folder": "handshakes",
        "path": "src/components/handshakes/HandshakeCard.tsx",
        "importPath": "@/components/handshakes/HandshakeCard"
    },
    {
        "name": "Handshakes",
        "fileName": "Handshakes",
        "folder": "handshakes",
        "path": "src/components/handshakes/Handshakes.tsx",
        "importPath": "@/components/handshakes/Handshakes"
    },
    {
        "name": "Auth",
        "fileName": "Auth",
        "folder": "login",
        "path": "src/components/login/Auth.tsx",
        "importPath": "@/components/login/Auth"
    },
    {
        "name": "LoginForm",
        "fileName": "LoginForm",
        "folder": "login",
        "path": "src/components/login/LoginForm.tsx",
        "importPath": "@/components/login/LoginForm"
    },
    {
        "name": "OAuthButton",
        "fileName": "OAuthButton",
        "folder": "login",
        "path": "src/components/login/OAuthButton.tsx",
        "importPath": "@/components/login/OAuthButton"
    },
    {
        "name": "OAuthConnectButton",
        "fileName": "OAuthConnectButton",
        "folder": "login",
        "path": "src/components/login/OAuthConnectButton.tsx",
        "importPath": "@/components/login/OAuthConnectButton"
    },
    {
        "name": "OAuthDisconnectButton",
        "fileName": "OAuthDisconnectButton",
        "folder": "login",
        "path": "src/components/login/OAuthDisconnectButton.tsx",
        "importPath": "@/components/login/OAuthDisconnectButton"
    },
    {
        "name": "OAuthGroup",
        "fileName": "OAuthGroup",
        "folder": "login",
        "path": "src/components/login/OAuthGroup.tsx",
        "importPath": "@/components/login/OAuthGroup"
    },
    {
        "name": "SignUpForm",
        "fileName": "SignUpForm",
        "folder": "login",
        "path": "src/components/login/SignUpForm.tsx",
        "importPath": "@/components/login/SignUpForm"
    },
    {
        "name": "ChannelDrawer",
        "fileName": "ChannelDrawer",
        "folder": "messages",
        "path": "src/components/messages/ChannelDrawer.tsx",
        "importPath": "@/components/messages/ChannelDrawer"
    },
    {
        "name": "Chat",
        "fileName": "Chat",
        "folder": "messages",
        "path": "src/components/messages/Chat.tsx",
        "importPath": "@/components/messages/Chat"
    },
    {
        "name": "ChatModal",
        "fileName": "ChatModal",
        "folder": "messages",
        "path": "src/components/messages/ChatModal.tsx",
        "importPath": "@/components/messages/ChatModal"
    },
    {
        "name": "ChatWindow",
        "fileName": "ChatWindow",
        "folder": "messages",
        "path": "src/components/messages/ChatWindow.tsx",
        "importPath": "@/components/messages/ChatWindow"
    },
    {
        "name": "DMList",
        "fileName": "DMList",
        "folder": "messages",
        "path": "src/components/messages/DMList.tsx",
        "importPath": "@/components/messages/DMList"
    },
    {
        "name": "DMsModal",
        "fileName": "DMsModal",
        "folder": "messages",
        "path": "src/components/messages/DMsModal.tsx",
        "importPath": "@/components/messages/DMsModal"
    },
    {
        "name": "Message",
        "fileName": "Message",
        "folder": "messages",
        "path": "src/components/messages/Message.tsx",
        "importPath": "@/components/messages/Message"
    },
    {
        "name": "MessageBubble",
        "fileName": "MessageBubble",
        "folder": "messages",
        "path": "src/components/messages/MessageBubble.tsx",
        "importPath": "@/components/messages/MessageBubble"
    },
    {
        "name": "MessageGroup",
        "fileName": "MessageGroup",
        "folder": "messages",
        "path": "src/components/messages/MessageGroup.tsx",
        "importPath": "@/components/messages/MessageGroup"
    },
    {
        "name": "MessageList",
        "fileName": "MessageList",
        "folder": "messages",
        "path": "src/components/messages/MessageList.tsx",
        "importPath": "@/components/messages/MessageList"
    },
    {
        "name": "AppNavigator",
        "fileName": "AppNavigator",
        "folder": "navigation",
        "path": "src/components/navigation/AppNavigator.tsx",
        "importPath": "@/components/navigation/AppNavigator"
    },
    {
        "name": "AppSidebar",
        "fileName": "Sidebar",
        "folder": "navigation",
        "path": "src/components/navigation/Sidebar.tsx",
        "importPath": "@/components/navigation/Sidebar"
    },
    {
        "name": "Layout",
        "fileName": "Layout",
        "folder": "navigation",
        "path": "src/components/navigation/Layout.tsx",
        "importPath": "@/components/navigation/Layout"
    },
    {
        "name": "MobileTabBar",
        "fileName": "MobileTabBar",
        "folder": "navigation",
        "path": "src/components/navigation/MobileTabBar.tsx",
        "importPath": "@/components/navigation/MobileTabBar"
    },
    {
        "name": "Navbar",
        "fileName": "Navbar",
        "folder": "navigation",
        "path": "src/components/navigation/Navbar.tsx",
        "importPath": "@/components/navigation/Navbar"
    },
    {
        "name": "PublicOnly",
        "fileName": "PublicOnly",
        "folder": "navigation",
        "path": "src/components/navigation/PublicOnly.tsx",
        "importPath": "@/components/navigation/PublicOnly"
    },
    {
        "name": "RequireAuth",
        "fileName": "RequireAuth",
        "folder": "navigation",
        "path": "src/components/navigation/RequireAuth.tsx",
        "importPath": "@/components/navigation/RequireAuth"
    },
    {
        "name": "SearchBar",
        "fileName": "SearchBar",
        "folder": "navigation",
        "path": "src/components/navigation/SearchBar.tsx",
        "importPath": "@/components/navigation/SearchBar"
    },
    {
        "name": "SearchModal",
        "fileName": "SearchModal",
        "folder": "navigation",
        "path": "src/components/navigation/SearchModal.tsx",
        "importPath": "@/components/navigation/SearchModal"
    },
    {
        "name": "NotificationsBell",
        "fileName": "NotificationsBell",
        "folder": "notifications",
        "path": "src/components/notifications/NotificationsBell.tsx",
        "importPath": "@/components/notifications/NotificationsBell"
    },
    {
        "name": "DonationAmountPicker",
        "fileName": "DonationAmountPicker",
        "folder": "payment",
        "path": "src/components/payment/DonationAmountPicker.tsx",
        "importPath": "@/components/payment/DonationAmountPicker"
    },
    {
        "name": "PaymentStatusListener",
        "fileName": "PaymentStatus",
        "folder": "payment",
        "path": "src/components/payment/PaymentStatus.tsx",
        "importPath": "@/components/payment/PaymentStatus"
    },
    {
        "name": "StripeWeb",
        "fileName": "Stripe",
        "folder": "payment",
        "path": "src/components/payment/Stripe.tsx",
        "importPath": "@/components/payment/Stripe"
    },
    {
        "name": "CreatePost",
        "fileName": "CreatePost",
        "folder": "posts",
        "path": "src/components/posts/CreatePost.tsx",
        "importPath": "@/components/posts/CreatePost"
    },
    {
        "name": "MessageList",
        "fileName": "MessageList",
        "folder": "posts",
        "path": "src/components/posts/MessageList.tsx",
        "importPath": "@/components/posts/MessageList"
    },
    {
        "name": "PostCard",
        "fileName": "PostCard",
        "folder": "posts",
        "path": "src/components/posts/PostCard.tsx",
        "importPath": "@/components/posts/PostCard"
    },
    {
        "name": "PostDetails",
        "fileName": "PostDetails",
        "folder": "posts",
        "path": "src/components/posts/PostDetails.tsx",
        "importPath": "@/components/posts/PostDetails"
    },
    {
        "name": "PostEditForm",
        "fileName": "PostEditForm",
        "folder": "posts",
        "path": "src/components/posts/PostEditForm.tsx",
        "importPath": "@/components/posts/PostEditForm"
    },
    {
        "name": "PostsContainer",
        "fileName": "PostsContainer",
        "folder": "posts",
        "path": "src/components/posts/PostsContainer.tsx",
        "importPath": "@/components/posts/PostsContainer"
    },
    {
        "name": "PostsInfinite",
        "fileName": "PostsInfinite",
        "folder": "posts",
        "path": "src/components/posts/PostsInfinite.tsx",
        "importPath": "@/components/posts/PostsInfinite"
    },
    {
        "name": "Carousel",
        "fileName": "Carousel",
        "folder": "root",
        "path": "src/components/Carousel.tsx",
        "importPath": "@/components/Carousel"
    },
    {
        "name": "ConfirmationModal",
        "fileName": "ConfirmationModal",
        "folder": "root",
        "path": "src/components/ConfirmationModal.tsx",
        "importPath": "@/components/ConfirmationModal"
    },
    {
        "name": "ImageModalCarousel",
        "fileName": "ImageModalCarousel",
        "folder": "root",
        "path": "src/components/ImageModalCarousel.tsx",
        "importPath": "@/components/ImageModalCarousel"
    },
    {
        "name": "Leaderboard",
        "fileName": "Leaderboard",
        "folder": "root",
        "path": "src/components/Leaderboard.tsx",
        "importPath": "@/components/Leaderboard"
    },
    {
        "name": "Map",
        "fileName": "Map",
        "folder": "root",
        "path": "src/components/Map.tsx",
        "importPath": "@/components/Map"
    },
    {
        "name": "TagInput",
        "fileName": "TagInput",
        "folder": "root",
        "path": "src/components/TagInput.tsx",
        "importPath": "@/components/TagInput"
    },
    {
        "name": "UniversalDatePickerWeb",
        "fileName": "DatePicker",
        "folder": "root",
        "path": "src/components/DatePicker.tsx",
        "importPath": "@/components/DatePicker"
    },
    {
        "name": "AvatarComponent",
        "fileName": "Avatar",
        "folder": "users",
        "path": "src/components/users/Avatar.tsx",
        "importPath": "@/components/users/Avatar"
    },
    {
        "name": "InviteForm",
        "fileName": "InviteForm",
        "folder": "users",
        "path": "src/components/users/InviteForm.tsx",
        "importPath": "@/components/users/InviteForm"
    },
    {
        "name": "InviteManager",
        "fileName": "InviteManager",
        "folder": "users",
        "path": "src/components/users/InviteManager.tsx",
        "importPath": "@/components/users/InviteManager"
    },
    {
        "name": "KudosHistory",
        "fileName": "KudosHistory",
        "folder": "users",
        "path": "src/components/users/KudosHistory.tsx",
        "importPath": "@/components/users/KudosHistory"
    },
    {
        "name": "Profile",
        "fileName": "Profile",
        "folder": "users",
        "path": "src/components/users/Profile.tsx",
        "importPath": "@/components/users/Profile"
    },
    {
        "name": "ProfileHeader",
        "fileName": "ProfileHeader",
        "folder": "users",
        "path": "src/components/users/ProfileHeader.tsx",
        "importPath": "@/components/users/ProfileHeader"
    },
    {
        "name": "ReportPastGiftModal",
        "fileName": "ReportPastGiftModal",
        "folder": "users",
        "path": "src/components/users/ReportPastGiftModal.tsx",
        "importPath": "@/components/users/ReportPastGiftModal"
    },
    {
        "name": "UserCard",
        "fileName": "UserCard",
        "folder": "users",
        "path": "src/components/users/UserCard.tsx",
        "importPath": "@/components/users/UserCard"
    },
    {
        "name": "ActionsBar",
        "fileName": "ActionsBar",
        "folder": "users/edit",
        "path": "src/components/users/edit/ActionsBar.tsx",
        "importPath": "@/components/users/edit/ActionsBar"
    },
    {
        "name": "AvatarMenu",
        "fileName": "AvatarMenu",
        "folder": "users/edit",
        "path": "src/components/users/edit/AvatarMenu.tsx",
        "importPath": "@/components/users/edit/AvatarMenu"
    },
    {
        "name": "EditProfile",
        "fileName": "EditProfile",
        "folder": "users/edit",
        "path": "src/components/users/edit/EditProfile.tsx",
        "importPath": "@/components/users/edit/EditProfile"
    },
    {
        "name": "ErrorList",
        "fileName": "ErrorList",
        "folder": "users/edit",
        "path": "src/components/users/edit/ErrorList.tsx",
        "importPath": "@/components/users/edit/ErrorList"
    },
    {
        "name": "FormField",
        "fileName": "FormField",
        "folder": "users/edit",
        "path": "src/components/users/edit/FormField.tsx",
        "importPath": "@/components/users/edit/FormField"
    },
    {
        "name": "PageHeader",
        "fileName": "PageHeader",
        "folder": "users/edit",
        "path": "src/components/users/edit/PageHeader.tsx",
        "importPath": "@/components/users/edit/PageHeader"
    },
    {
        "name": "PreviewAvatar",
        "fileName": "PreviewAvatar",
        "folder": "users/edit",
        "path": "src/components/users/edit/PreviewAvatar.tsx",
        "importPath": "@/components/users/edit/PreviewAvatar"
    },
    {
        "name": "SettingsSection",
        "fileName": "SettingsSection",
        "folder": "users/edit",
        "path": "src/components/users/edit/SettingsSection.tsx",
        "importPath": "@/components/users/edit/SettingsSection"
    }
];

export const componentsByFolder: Record<string, ComponentInfo[]> = {
    "admin": [
        {
            "name": "AdminAnalytics",
            "fileName": "AdminAnalytics",
            "folder": "admin",
            "path": "src/components/admin/AdminAnalytics.tsx",
            "importPath": "@/components/admin/AdminAnalytics"
        },
        {
            "name": "AdminReportModal",
            "fileName": "AdminReportModal",
            "folder": "admin",
            "path": "src/components/admin/AdminReportModal.tsx",
            "importPath": "@/components/admin/AdminReportModal"
        },
        {
            "name": "Dashboard",
            "fileName": "ReportsDashboard",
            "folder": "admin",
            "path": "src/components/admin/ReportsDashboard.tsx",
            "importPath": "@/components/admin/ReportsDashboard"
        },
        {
            "name": "FeedbackDashboard",
            "fileName": "FeedbackDashboard",
            "folder": "admin",
            "path": "src/components/admin/FeedbackDashboard.tsx",
            "importPath": "@/components/admin/FeedbackDashboard"
        },
        {
            "name": "ReportCard",
            "fileName": "ReportCard",
            "folder": "admin",
            "path": "src/components/admin/ReportCard.tsx",
            "importPath": "@/components/admin/ReportCard"
        },
        {
            "name": "RewardKudosModal",
            "fileName": "RewardKudosModal",
            "folder": "admin",
            "path": "src/components/admin/RewardKudosModal.tsx",
            "importPath": "@/components/admin/RewardKudosModal"
        }
    ],
    "common": [
        {
            "name": "Alert",
            "fileName": "Alert",
            "folder": "common",
            "path": "src/components/common/Alert.tsx",
            "importPath": "@/components/common/Alert"
        },
        {
            "name": "AlertHost",
            "fileName": "AlertHost",
            "folder": "common",
            "path": "src/components/common/AlertHost.tsx",
            "importPath": "@/components/common/AlertHost"
        },
        {
            "name": "Button",
            "fileName": "Button",
            "folder": "common",
            "path": "src/components/common/Button.tsx",
            "importPath": "@/components/common/Button"
        },
        {
            "name": "ConnectingOverlay",
            "fileName": "ConnectingOverlay",
            "folder": "common",
            "path": "src/components/common/ConnectingOverlay.tsx",
            "importPath": "@/components/common/ConnectingOverlay"
        },
        {
            "name": "Drawer",
            "fileName": "Drawer",
            "folder": "common",
            "path": "src/components/common/Drawer.tsx",
            "importPath": "@/components/common/Drawer"
        },
        {
            "name": "Dropdown",
            "fileName": "Dropdown",
            "folder": "common",
            "path": "src/components/common/Dropdown.tsx",
            "importPath": "@/components/common/Dropdown"
        },
        {
            "name": "FeedbackModal",
            "fileName": "FeedbackModal",
            "folder": "common",
            "path": "src/components/common/FeedbackModal.tsx",
            "importPath": "@/components/common/FeedbackModal"
        },
        {
            "name": "Modal",
            "fileName": "Modal",
            "folder": "common",
            "path": "src/components/common/Modal.tsx",
            "importPath": "@/components/common/Modal"
        },
        {
            "name": "Pill",
            "fileName": "Pill",
            "folder": "common",
            "path": "src/components/common/Pill.tsx",
            "importPath": "@/components/common/Pill"
        },
        {
            "name": "SlideInOnScroll",
            "fileName": "SlideInOnScroll",
            "folder": "common",
            "path": "src/components/common/SlideInOnScroll.tsx",
            "importPath": "@/components/common/SlideInOnScroll"
        },
        {
            "name": "Spinner",
            "fileName": "Spinner",
            "folder": "common",
            "path": "src/components/common/Spinner.tsx",
            "importPath": "@/components/common/Spinner"
        },
        {
            "name": "TextWithLinks",
            "fileName": "TextWithLinks",
            "folder": "common",
            "path": "src/components/common/TextWithLinks.tsx",
            "importPath": "@/components/common/TextWithLinks"
        }
    ],
    "communities": [
        {
            "name": "Communities",
            "fileName": "Communities",
            "folder": "communities",
            "path": "src/components/communities/Communities.tsx",
            "importPath": "@/components/communities/Communities"
        }
    ],
    "dev": [
        {
            "name": "DevToolsPanel",
            "fileName": "DevToolsPanel",
            "folder": "dev",
            "path": "src/components/dev/DevToolsPanel.tsx",
            "importPath": "@/components/dev/DevToolsPanel"
        }
    ],
    "dev/sections": [
        {
            "name": "AddCommentsSection",
            "fileName": "AddCommentsSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/AddCommentsSection.tsx",
            "importPath": "@/components/dev/sections/AddCommentsSection"
        },
        {
            "name": "AddHandshakeSection",
            "fileName": "AddHandshakeSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/AddHandshakeSection.tsx",
            "importPath": "@/components/dev/sections/AddHandshakeSection"
        },
        {
            "name": "LogsFilterBar",
            "fileName": "LogsFilterBar",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/LogsFilterBar.tsx",
            "importPath": "@/components/dev/sections/LogsFilterBar"
        },
        {
            "name": "LogsSection",
            "fileName": "LogsSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/LogsSection.tsx",
            "importPath": "@/components/dev/sections/LogsSection"
        },
        {
            "name": "PostDebugSection",
            "fileName": "PostDebugSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/PostDebugSection.tsx",
            "importPath": "@/components/dev/sections/PostDebugSection"
        },
        {
            "name": "RecordingsSection",
            "fileName": "RecordingsSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/RecordingsSection.tsx",
            "importPath": "@/components/dev/sections/RecordingsSection"
        },
        {
            "name": "SearchDebugSection",
            "fileName": "SearchDebugSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/SearchDebugSection.tsx",
            "importPath": "@/components/dev/sections/SearchDebugSection"
        },
        {
            "name": "StateDebugSection",
            "fileName": "StateDebugSection",
            "folder": "dev/sections",
            "path": "src/components/dev/sections/StateDebugSection.tsx",
            "importPath": "@/components/dev/sections/StateDebugSection"
        }
    ],
    "events": [
        {
            "name": "CreateEvent",
            "fileName": "CreateEvent",
            "folder": "events",
            "path": "src/components/events/CreateEvent.tsx",
            "importPath": "@/components/events/CreateEvent"
        },
        {
            "name": "EventCard",
            "fileName": "EventCard",
            "folder": "events",
            "path": "src/components/events/EventCard.tsx",
            "importPath": "@/components/events/EventCard"
        },
        {
            "name": "EventDetails",
            "fileName": "EventDetails",
            "folder": "events",
            "path": "src/components/events/EventDetails.tsx",
            "importPath": "@/components/events/EventDetails"
        },
        {
            "name": "Events",
            "fileName": "EventsCalendar",
            "folder": "events",
            "path": "src/components/events/EventsCalendar.tsx",
            "importPath": "@/components/events/EventsCalendar"
        },
        {
            "name": "EventsCarousel",
            "fileName": "EventsCarousel",
            "folder": "events",
            "path": "src/components/events/EventsCarousel.tsx",
            "importPath": "@/components/events/EventsCarousel"
        },
        {
            "name": "GanttEventsCalendar",
            "fileName": "GanttEventsCalendar",
            "folder": "events",
            "path": "src/components/events/GanttEventsCalendar.tsx",
            "importPath": "@/components/events/GanttEventsCalendar"
        },
        {
            "name": "MobileEventListView",
            "fileName": "MobileEventListView",
            "folder": "events",
            "path": "src/components/events/MobileEventListView.tsx",
            "importPath": "@/components/events/MobileEventListView"
        }
    ],
    "forms": [
        {
            "name": "DropdownPicker",
            "fileName": "DropdownPicker",
            "folder": "forms",
            "path": "src/components/forms/DropdownPicker.tsx",
            "importPath": "@/components/forms/DropdownPicker"
        },
        {
            "name": "FilePicker",
            "fileName": "FilePicker",
            "folder": "forms",
            "path": "src/components/forms/FilePicker.tsx",
            "importPath": "@/components/forms/FilePicker"
        },
        {
            "name": "Form",
            "fileName": "Form",
            "folder": "forms",
            "path": "src/components/forms/Form.tsx",
            "importPath": "@/components/forms/Form"
        },
        {
            "name": "FormField",
            "fileName": "FormField",
            "folder": "forms",
            "path": "src/components/forms/FormField.tsx",
            "importPath": "@/components/forms/FormField"
        },
        {
            "name": "ImagePicker",
            "fileName": "ImagePicker",
            "folder": "forms",
            "path": "src/components/forms/ImagePicker.tsx",
            "importPath": "@/components/forms/ImagePicker"
        },
        {
            "name": "Input",
            "fileName": "Input",
            "folder": "forms",
            "path": "src/components/forms/Input.tsx",
            "importPath": "@/components/forms/Input"
        }
    ],
    "handshakes": [
        {
            "name": "HandshakeCard",
            "fileName": "HandshakeCard",
            "folder": "handshakes",
            "path": "src/components/handshakes/HandshakeCard.tsx",
            "importPath": "@/components/handshakes/HandshakeCard"
        },
        {
            "name": "Handshakes",
            "fileName": "Handshakes",
            "folder": "handshakes",
            "path": "src/components/handshakes/Handshakes.tsx",
            "importPath": "@/components/handshakes/Handshakes"
        }
    ],
    "login": [
        {
            "name": "Auth",
            "fileName": "Auth",
            "folder": "login",
            "path": "src/components/login/Auth.tsx",
            "importPath": "@/components/login/Auth"
        },
        {
            "name": "LoginForm",
            "fileName": "LoginForm",
            "folder": "login",
            "path": "src/components/login/LoginForm.tsx",
            "importPath": "@/components/login/LoginForm"
        },
        {
            "name": "OAuthButton",
            "fileName": "OAuthButton",
            "folder": "login",
            "path": "src/components/login/OAuthButton.tsx",
            "importPath": "@/components/login/OAuthButton"
        },
        {
            "name": "OAuthConnectButton",
            "fileName": "OAuthConnectButton",
            "folder": "login",
            "path": "src/components/login/OAuthConnectButton.tsx",
            "importPath": "@/components/login/OAuthConnectButton"
        },
        {
            "name": "OAuthDisconnectButton",
            "fileName": "OAuthDisconnectButton",
            "folder": "login",
            "path": "src/components/login/OAuthDisconnectButton.tsx",
            "importPath": "@/components/login/OAuthDisconnectButton"
        },
        {
            "name": "OAuthGroup",
            "fileName": "OAuthGroup",
            "folder": "login",
            "path": "src/components/login/OAuthGroup.tsx",
            "importPath": "@/components/login/OAuthGroup"
        },
        {
            "name": "SignUpForm",
            "fileName": "SignUpForm",
            "folder": "login",
            "path": "src/components/login/SignUpForm.tsx",
            "importPath": "@/components/login/SignUpForm"
        }
    ],
    "messages": [
        {
            "name": "ChannelDrawer",
            "fileName": "ChannelDrawer",
            "folder": "messages",
            "path": "src/components/messages/ChannelDrawer.tsx",
            "importPath": "@/components/messages/ChannelDrawer"
        },
        {
            "name": "Chat",
            "fileName": "Chat",
            "folder": "messages",
            "path": "src/components/messages/Chat.tsx",
            "importPath": "@/components/messages/Chat"
        },
        {
            "name": "ChatModal",
            "fileName": "ChatModal",
            "folder": "messages",
            "path": "src/components/messages/ChatModal.tsx",
            "importPath": "@/components/messages/ChatModal"
        },
        {
            "name": "ChatWindow",
            "fileName": "ChatWindow",
            "folder": "messages",
            "path": "src/components/messages/ChatWindow.tsx",
            "importPath": "@/components/messages/ChatWindow"
        },
        {
            "name": "DMList",
            "fileName": "DMList",
            "folder": "messages",
            "path": "src/components/messages/DMList.tsx",
            "importPath": "@/components/messages/DMList"
        },
        {
            "name": "DMsModal",
            "fileName": "DMsModal",
            "folder": "messages",
            "path": "src/components/messages/DMsModal.tsx",
            "importPath": "@/components/messages/DMsModal"
        },
        {
            "name": "Message",
            "fileName": "Message",
            "folder": "messages",
            "path": "src/components/messages/Message.tsx",
            "importPath": "@/components/messages/Message"
        },
        {
            "name": "MessageBubble",
            "fileName": "MessageBubble",
            "folder": "messages",
            "path": "src/components/messages/MessageBubble.tsx",
            "importPath": "@/components/messages/MessageBubble"
        },
        {
            "name": "MessageGroup",
            "fileName": "MessageGroup",
            "folder": "messages",
            "path": "src/components/messages/MessageGroup.tsx",
            "importPath": "@/components/messages/MessageGroup"
        },
        {
            "name": "MessageList",
            "fileName": "MessageList",
            "folder": "messages",
            "path": "src/components/messages/MessageList.tsx",
            "importPath": "@/components/messages/MessageList"
        }
    ],
    "navigation": [
        {
            "name": "AppNavigator",
            "fileName": "AppNavigator",
            "folder": "navigation",
            "path": "src/components/navigation/AppNavigator.tsx",
            "importPath": "@/components/navigation/AppNavigator"
        },
        {
            "name": "AppSidebar",
            "fileName": "Sidebar",
            "folder": "navigation",
            "path": "src/components/navigation/Sidebar.tsx",
            "importPath": "@/components/navigation/Sidebar"
        },
        {
            "name": "Layout",
            "fileName": "Layout",
            "folder": "navigation",
            "path": "src/components/navigation/Layout.tsx",
            "importPath": "@/components/navigation/Layout"
        },
        {
            "name": "MobileTabBar",
            "fileName": "MobileTabBar",
            "folder": "navigation",
            "path": "src/components/navigation/MobileTabBar.tsx",
            "importPath": "@/components/navigation/MobileTabBar"
        },
        {
            "name": "Navbar",
            "fileName": "Navbar",
            "folder": "navigation",
            "path": "src/components/navigation/Navbar.tsx",
            "importPath": "@/components/navigation/Navbar"
        },
        {
            "name": "PublicOnly",
            "fileName": "PublicOnly",
            "folder": "navigation",
            "path": "src/components/navigation/PublicOnly.tsx",
            "importPath": "@/components/navigation/PublicOnly"
        },
        {
            "name": "RequireAuth",
            "fileName": "RequireAuth",
            "folder": "navigation",
            "path": "src/components/navigation/RequireAuth.tsx",
            "importPath": "@/components/navigation/RequireAuth"
        },
        {
            "name": "SearchBar",
            "fileName": "SearchBar",
            "folder": "navigation",
            "path": "src/components/navigation/SearchBar.tsx",
            "importPath": "@/components/navigation/SearchBar"
        },
        {
            "name": "SearchModal",
            "fileName": "SearchModal",
            "folder": "navigation",
            "path": "src/components/navigation/SearchModal.tsx",
            "importPath": "@/components/navigation/SearchModal"
        }
    ],
    "notifications": [
        {
            "name": "NotificationsBell",
            "fileName": "NotificationsBell",
            "folder": "notifications",
            "path": "src/components/notifications/NotificationsBell.tsx",
            "importPath": "@/components/notifications/NotificationsBell"
        }
    ],
    "payment": [
        {
            "name": "DonationAmountPicker",
            "fileName": "DonationAmountPicker",
            "folder": "payment",
            "path": "src/components/payment/DonationAmountPicker.tsx",
            "importPath": "@/components/payment/DonationAmountPicker"
        },
        {
            "name": "PaymentStatusListener",
            "fileName": "PaymentStatus",
            "folder": "payment",
            "path": "src/components/payment/PaymentStatus.tsx",
            "importPath": "@/components/payment/PaymentStatus"
        },
        {
            "name": "StripeWeb",
            "fileName": "Stripe",
            "folder": "payment",
            "path": "src/components/payment/Stripe.tsx",
            "importPath": "@/components/payment/Stripe"
        }
    ],
    "posts": [
        {
            "name": "CreatePost",
            "fileName": "CreatePost",
            "folder": "posts",
            "path": "src/components/posts/CreatePost.tsx",
            "importPath": "@/components/posts/CreatePost"
        },
        {
            "name": "MessageList",
            "fileName": "MessageList",
            "folder": "posts",
            "path": "src/components/posts/MessageList.tsx",
            "importPath": "@/components/posts/MessageList"
        },
        {
            "name": "PostCard",
            "fileName": "PostCard",
            "folder": "posts",
            "path": "src/components/posts/PostCard.tsx",
            "importPath": "@/components/posts/PostCard"
        },
        {
            "name": "PostDetails",
            "fileName": "PostDetails",
            "folder": "posts",
            "path": "src/components/posts/PostDetails.tsx",
            "importPath": "@/components/posts/PostDetails"
        },
        {
            "name": "PostEditForm",
            "fileName": "PostEditForm",
            "folder": "posts",
            "path": "src/components/posts/PostEditForm.tsx",
            "importPath": "@/components/posts/PostEditForm"
        },
        {
            "name": "PostsContainer",
            "fileName": "PostsContainer",
            "folder": "posts",
            "path": "src/components/posts/PostsContainer.tsx",
            "importPath": "@/components/posts/PostsContainer"
        },
        {
            "name": "PostsInfinite",
            "fileName": "PostsInfinite",
            "folder": "posts",
            "path": "src/components/posts/PostsInfinite.tsx",
            "importPath": "@/components/posts/PostsInfinite"
        }
    ],
    "root": [
        {
            "name": "Carousel",
            "fileName": "Carousel",
            "folder": "root",
            "path": "src/components/Carousel.tsx",
            "importPath": "@/components/Carousel"
        },
        {
            "name": "ConfirmationModal",
            "fileName": "ConfirmationModal",
            "folder": "root",
            "path": "src/components/ConfirmationModal.tsx",
            "importPath": "@/components/ConfirmationModal"
        },
        {
            "name": "ImageModalCarousel",
            "fileName": "ImageModalCarousel",
            "folder": "root",
            "path": "src/components/ImageModalCarousel.tsx",
            "importPath": "@/components/ImageModalCarousel"
        },
        {
            "name": "Leaderboard",
            "fileName": "Leaderboard",
            "folder": "root",
            "path": "src/components/Leaderboard.tsx",
            "importPath": "@/components/Leaderboard"
        },
        {
            "name": "Map",
            "fileName": "Map",
            "folder": "root",
            "path": "src/components/Map.tsx",
            "importPath": "@/components/Map"
        },
        {
            "name": "TagInput",
            "fileName": "TagInput",
            "folder": "root",
            "path": "src/components/TagInput.tsx",
            "importPath": "@/components/TagInput"
        },
        {
            "name": "UniversalDatePickerWeb",
            "fileName": "DatePicker",
            "folder": "root",
            "path": "src/components/DatePicker.tsx",
            "importPath": "@/components/DatePicker"
        }
    ],
    "users": [
        {
            "name": "AvatarComponent",
            "fileName": "Avatar",
            "folder": "users",
            "path": "src/components/users/Avatar.tsx",
            "importPath": "@/components/users/Avatar"
        },
        {
            "name": "InviteForm",
            "fileName": "InviteForm",
            "folder": "users",
            "path": "src/components/users/InviteForm.tsx",
            "importPath": "@/components/users/InviteForm"
        },
        {
            "name": "InviteManager",
            "fileName": "InviteManager",
            "folder": "users",
            "path": "src/components/users/InviteManager.tsx",
            "importPath": "@/components/users/InviteManager"
        },
        {
            "name": "KudosHistory",
            "fileName": "KudosHistory",
            "folder": "users",
            "path": "src/components/users/KudosHistory.tsx",
            "importPath": "@/components/users/KudosHistory"
        },
        {
            "name": "Profile",
            "fileName": "Profile",
            "folder": "users",
            "path": "src/components/users/Profile.tsx",
            "importPath": "@/components/users/Profile"
        },
        {
            "name": "ProfileHeader",
            "fileName": "ProfileHeader",
            "folder": "users",
            "path": "src/components/users/ProfileHeader.tsx",
            "importPath": "@/components/users/ProfileHeader"
        },
        {
            "name": "ReportPastGiftModal",
            "fileName": "ReportPastGiftModal",
            "folder": "users",
            "path": "src/components/users/ReportPastGiftModal.tsx",
            "importPath": "@/components/users/ReportPastGiftModal"
        },
        {
            "name": "UserCard",
            "fileName": "UserCard",
            "folder": "users",
            "path": "src/components/users/UserCard.tsx",
            "importPath": "@/components/users/UserCard"
        }
    ],
    "users/edit": [
        {
            "name": "ActionsBar",
            "fileName": "ActionsBar",
            "folder": "users/edit",
            "path": "src/components/users/edit/ActionsBar.tsx",
            "importPath": "@/components/users/edit/ActionsBar"
        },
        {
            "name": "AvatarMenu",
            "fileName": "AvatarMenu",
            "folder": "users/edit",
            "path": "src/components/users/edit/AvatarMenu.tsx",
            "importPath": "@/components/users/edit/AvatarMenu"
        },
        {
            "name": "EditProfile",
            "fileName": "EditProfile",
            "folder": "users/edit",
            "path": "src/components/users/edit/EditProfile.tsx",
            "importPath": "@/components/users/edit/EditProfile"
        },
        {
            "name": "ErrorList",
            "fileName": "ErrorList",
            "folder": "users/edit",
            "path": "src/components/users/edit/ErrorList.tsx",
            "importPath": "@/components/users/edit/ErrorList"
        },
        {
            "name": "FormField",
            "fileName": "FormField",
            "folder": "users/edit",
            "path": "src/components/users/edit/FormField.tsx",
            "importPath": "@/components/users/edit/FormField"
        },
        {
            "name": "PageHeader",
            "fileName": "PageHeader",
            "folder": "users/edit",
            "path": "src/components/users/edit/PageHeader.tsx",
            "importPath": "@/components/users/edit/PageHeader"
        },
        {
            "name": "PreviewAvatar",
            "fileName": "PreviewAvatar",
            "folder": "users/edit",
            "path": "src/components/users/edit/PreviewAvatar.tsx",
            "importPath": "@/components/users/edit/PreviewAvatar"
        },
        {
            "name": "SettingsSection",
            "fileName": "SettingsSection",
            "folder": "users/edit",
            "path": "src/components/users/edit/SettingsSection.tsx",
            "importPath": "@/components/users/edit/SettingsSection"
        }
    ]
};

export const folders = [
    "admin",
    "common",
    "communities",
    "dev",
    "dev/sections",
    "events",
    "forms",
    "handshakes",
    "login",
    "messages",
    "navigation",
    "notifications",
    "payment",
    "posts",
    "root",
    "users",
    "users/edit"
];
